module.exports = __webpack_public_path__ + "img/backward-15-seconds.c59bd0e5.svg";